module.exports = __webpack_public_path__ + "img/alb.4eb491e7.svg";